/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { ISfiCodeRequest } from '../models/sfi-code.model';

export class LoadSfiCodes {
  static readonly type = '[SfiCode] Load SfiCodes via Service';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadAllSfiCodes {
  static readonly type = '[SfiCode] Load All SfiCodes via Service';
  constructor() {}
}

export class LoadAllSfiCodesPerDepartment {
  static readonly type = '[SfiCode] Load All Sfi Codes Per Department via Service';
  constructor() {}
}

export class LoadSfiCodeById {
  static readonly type = '[SfiCode] Load a single sfi code';
  constructor(public id: string) {}
}

export class CreateSfiCode {
  static readonly type = '[SfiCode] Create sfi code';
  constructor(public sfiCode: ISfiCodeRequest) {}
}

export class UpdateSfiCode {
  static readonly type = '[SfiCode] Update sfi code';
  constructor(public sfiCode: ISfiCodeRequest) {}
}

export class DeleteSfiCode {
  static readonly type = '[SfiCode] Delete sfi code';
  constructor(public id: string) {}
}
